import { render, staticRenderFns } from "./OfferListItem.vue?vue&type=template&id=52d88e41"
import script from "./OfferListItem.vue?vue&type=script&lang=js"
export * from "./OfferListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports